import {createDataStore} from './createDataStore';

// Caches /data/tensorflowData.json for the TensorFlow tutorial pages.
// See createDataStore for the fetch-once / persist-to-localStorage behaviour.
// Bump the version below whenever tensorflowData.json's content changes, to
// invalidate copies already cached in returning visitors' browsers.
export const useTensorflowDataStore = createDataStore(
    '/data/tensorflowData.json',
    'tensorflow-data-store',
    ['slugs', 'nextPage', 'relatedPages', 'suggestedCourses'],
    1
);
